import Vue from 'vue';
import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { to } from './promiseHandle';
import { Topics } from '@/models/Topic';
import { AuthenService } from '@/services/authen.service.ts';
import { CommonService } from '@/services/Common.service';

export class TopicsService extends Vue {
    private baseAPI = process.env.VUE_APP_API_URL;
    private commonAPI = process.env.VUE_APP_API_COMMON_URL;
    private token = localStorage.getItem('token');
    private authService = new AuthenService();
    private commonService = new CommonService();

    constructor() {
        super();
    }

    get headers() {
        return {
            'Content-Type': 'application/json',
            'auth': this.token,
        };
    }

    public async getKyotens() {
        return this.commonService.getKyotens();
    }

    public async getTopics(id?: number) {
        const url = id
            ? `${this.baseAPI}/topics/${id}`
            : `${this.baseAPI}/topics`;
        const { result, error } = await this.commonService.get(url);
        if (result) {
            return result.data;
        } else {
            return this.authService.handleError(error, 'getTopics');
        }
    }

    public async editTopic(data: Topics) {
        const {
            defDispKbn,
            enabled,
        } = data;

        const { result, error } = await this.commonService.put(`${this.baseAPI}/topics`, {
            ...data,
            defDispKbn: defDispKbn ? 1 : 0
        });

        if (result) {
            return result.status;
        } else {
            return this.authService.handleError(error, 'editTopic');
        }
    }

    public async deleteTopic(id: number) {
        const { result, error } = await this.commonService.delete(`${this.baseAPI}/topics/${id}`);
        if (result) {
            return result.status;
        } else {
            return this.authService.handleError(error, 'deleteTopic');
        }
    }

    public async saveTopicsOrderDisplay(data: any[]) {
        const { result, error } = await this.commonService.put(`${this.baseAPI}/topics-order-display/`, data);
        if (result) {
            return result.status;
        } else {
            return this.authService.handleError(error, 'saveTopicsOrderDisplay');
        }
    }



}
